import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DropDownOptions } from '../../models/app-models';
import { pageName } from 'src/app/shared/services/page.service';
import { Router } from '@angular/router';
import {
  ExtendedKeycloakUser,
  StoreDropdowns,
  UserInformation
} from 'src/app/shared/models/app-models';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { rfqListDropDown } from 'src/app/shared/models/app-models/DropDown.model';

@Component({
  selector: 'app-create-rfq-dialog',
  templateUrl: './create-rfq-dialog.component.html',
  styleUrls: ['./create-rfq-dialog.component.scss']
})
export class CreateRFQDialogComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  rfqNumbersData: DropDownOptions[] = [];
  userList: ExtendedKeycloakUser[] = [];
  selectedRFQ: DropDownOptions | null = null;
  constructor(private matDialogRef: MatDialogRef<CreateRFQDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router,
    private store: Store<{ dp: StoreDropdowns, user: UserInformation }>) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.userList = dp.UserList as ExtendedKeycloakUser[];
      });
    this.handledropdownOptions();
  }

  handledropdownOptions() {
    this.rfqNumbersData = this.data.rfqList.map((option: rfqListDropDown) => {
      const user = this.userList.find((user) => user.id == option?.PE);
      const dropdownOption = {
        id: option.RFQNumber,
        value: option.RFQNumber + ' (' + (user ? user.last_name : '') + ')',
        disabled: option.Status === 1 || (option.CreatedBy && option.CreatedBy !== this.data.loggedInUsername)
      };
      return dropdownOption;
    });
    return this.rfqNumbersData;
  }


  onCreate() {
    if (this.selectedRFQ) {
      const rfqSummaryNumber = this.data.rfqList.find((item: rfqListDropDown) => item.RFQNumber === this.selectedRFQ?.id)?.RFQSummaryNumber;
      if (rfqSummaryNumber) this.router.navigate(['/rfqSummary/', rfqSummaryNumber]);
      else {
        const data = {
          MPDocumentNumber: this.data?.MPDocumentNumber,
          RFQNumber: this.selectedRFQ?.id,
          fromRoute: pageName.My_Document
        }
        this.router.navigate(['/rfqSummary'], { state: { data: data } });
      }
    };
    this.matDialogRef.close();
  }

}
